import {
  AnyTeamGroupEntityVersion,
  FirestoreEntity,
  isNonEmptyString,
  Mapper,
  TeamGroup,
} from '@uploadcam/common';
import { CollectionReference, getDocs, query, QueryConstraint, where } from 'firebase/firestore';
import invariant from 'tiny-invariant';

export class GetTeamGroupsInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyTeamGroupEntityVersion>,
    private readonly mapper: Mapper<FirestoreEntity<AnyTeamGroupEntityVersion>, TeamGroup>,
  ) {}

  public async execute(teamId: string, userId?: string): Promise<TeamGroup[]> {
    invariant(isNonEmptyString(teamId), `'teamId' must be defined`);

    const teamGroupsQuery: QueryConstraint[] = [where('teamId', '==', teamId)];

    if (userId) {
      teamGroupsQuery.push(where('users', 'array-contains', userId));
    }

    const teamGroupsDocs = await getDocs(query(this.collection, ...teamGroupsQuery));

    return teamGroupsDocs.docs.map((doc) => this.mapper.map(FirestoreEntity.from(doc)));
  }
}
